<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('BookingOverview') }}
      <template #subtitle>
        {{ $t('BookingOverviewSub') }}
      </template>
      <template #action>
        <v-btn
          class="amber lighten-4 black--text mt-4"
          depressed
          @click="$emit('edit')"
        >
          <span
            class="text-truncate"
            style="max-width: 250px;"
          >
            {{ $t('BookingWebseiteConfig') }}
          </span>
        </v-btn>
      </template>
    </page-header>
    <v-row class="mt-4">
      <v-col cols="4">
        <dashboard-card
          :info="totalPersonCount + ' ' + $t('Pice')"
          :subtitle="$t('TotalPeopleHint')"
          :title="$t('TotalPeople')"
          color="yellow"
        />
      </v-col>
      <v-col cols="4">
        <dashboard-card
          :info="highTime"
          :subtitle="$t('RushHourHint')"
          :title="$t('RushHour')"
          color="pink"
        />
      </v-col>
      <v-col cols="4">
        <dashboard-card
          :info="$t('Online')"
          :subtitle="$t('BookingWebseiteStatusHint')"
          :title="$t('BookingWebseiteStatus')"
          color="green"
        >
          <template #action>
            <div>
              <v-img
                :src="QRCode"
                width="80"
              />
            </div>
          </template>
        </dashboard-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import DashboardCard from '@/views/AadenPages/dashboard/components/DashboardCard.vue'
import { getCurrentReservation } from '@/model/dataLayer/service/reservation/reservationStatistic'
import { sumBy } from 'lodash'
import { groupBy, maxBy } from 'lodash-es'
import dayjs from 'dayjs'

export default {
  name: 'ActiveDashboard',
  components: {
    DashboardCard,
    PageHeader
  },
  props: {
    info: {}
  },
  data: function () {
    return {
      QRCode: '',
      hostName: '',
      reservationInfo: null,
      reservations: []
    }
  },
  computed: {
    totalPersonCount () {
      return sumBy(this.reservations, 'personCount')
    },
    highTime () {
      const time = maxBy(Object.values(groupBy(this.reservations, 'fromDateTime')),
        'length')?.[0]?.fromDateTime
      return time ? dayjs(time).format('HH:mm') : '-'
    }
  },
  async mounted () {
    await this.reload()
    this.reservations = await getCurrentReservation()
  },
  methods: {
    async reload () {
      this.reserveStatus = this.info

      if (this.reserveStatus) {
        const hostName = 'https://' + this.info.subDominName + '.reservation.aaden.io'
        this.QRCode = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + hostName
      }
    }
  }
}
</script>

<style scoped>

</style>
